import ask from '@/utils/http'

export default {
  // 获取所有小程序
  getApplets: (params = {}) => ask.get(`/backstage/getApplets`, params),
  // 更新小程序
  updateApplets: (params = {}) => ask.get(`/backstage/updateApplets`, params),
}



// WEBPACK FOOTER //
// ./src/api/applets.js